'use strict';

var canonicalProperties = require('unicode-canonical-property-names-ecmascript');

var propertyAliases = require('unicode-property-aliases-ecmascript');

var matchProperty = function matchProperty(property) {
  if (canonicalProperties.has(property)) {
    return property;
  }

  if (propertyAliases.has(property)) {
    return propertyAliases.get(property);
  }

  throw new Error("Unknown property: ".concat(property));
};

module.exports = matchProperty;